import VueRouter from "vue-router";
import IndexView from "@/views/index.vue";

export const routes = [
  {
    path: "/",
    name: "index",
    component: IndexView,
  }
];

export default new VueRouter({
  // mode: "history",
  routes,
});
